import classnames from 'classnames/bind';
import styles from './frame.module.scss';

const classNameBuilder = classnames.bind(styles);

export const Frame = ({ children, frameStyle }) => (
    <div className={classNameBuilder(frameStyle)} id="codeless-frame">
        {children}
    </div>
);
